import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import type { FormMetadataParams } from "@/entities/form-metadata";
import { formMetadataQueryKeys } from "./formMetadataQueryKeys";
import { getFormMetadata } from "./getFormMetadata";
import { useMetadataParamsContext } from "./metadata-params-provider";

export const getMetadataQueryOptions = (formMetadataParams: FormMetadataParams) => {
    const formMetadataQueryKey = formMetadataQueryKeys.detail(formMetadataParams);

    return queryOptions({
        queryKey: formMetadataQueryKey,
        queryFn: () => getFormMetadata(formMetadataParams),
    });
};

export const useMetadataQuery = () => {
    const formMetadataParams = useMetadataParamsContext();

    return useSuspenseQuery(getMetadataQueryOptions(formMetadataParams));
};
